import { render, staticRenderFns } from "./ReworkManagement.vue?vue&type=template&id=3c6ed3b4&scoped=true&"
import script from "./ReworkManagement.vue?vue&type=script&lang=js&"
export * from "./ReworkManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReworkManagement.vue?vue&type=style&index=0&id=3c6ed3b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ed3b4",
  null
  
)

export default component.exports